import { FC, MutableRefObject, useContext } from 'react';
import { initialTransactionsDateFilterState, TransactionsDateFilterContext } from './TransactionsDateFilterContext';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import './TransactionsDateFilterButtons.scss';

export const TransactionsDateFilterButtons: FC<{ buttonRef: MutableRefObject<HTMLButtonElement | null> }> = ({
  buttonRef,
}) => {
  const { changed, popupOpened, setPopupOpened, setState } = useContext(TransactionsDateFilterContext);
  const { t } = useTranslation();

  return (
    <div className="TransactionsDateFilterButtons">
      <Button
        size="sm"
        variant={changed || popupOpened ? 'primary' : 'outline-primary'}
        onClick={() => {
          setPopupOpened(true);
        }}
        ref={buttonRef}
      >
        {changed ? t('Change filter') : t('Set filter')}
      </Button>

      {changed && (
        <Button
          size="sm"
          variant="light"
          onClick={() => {
            setState(initialTransactionsDateFilterState);
          }}
        >
          {t('Reset')}
        </Button>
      )}
    </div>
  );
};
